<template>
  <div>
    <vx-card class="mb-1">
        <vs-row vs-type="flex" vs-justify="space-between" >
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="3">         
              <label class="vs-input--label mr-2">Nome Fantasia ou Razão Social</label>              
              <vs-input class="mb-4 w-full" v-model="filtro.nome" @keyup.enter="fetchLista(filtro)" />
          </vs-col>                    
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="2">         
              <label class="vs-input--label ml-1">CPF ou CNPJ</label>              
              <vs-input class="mb-4 w-full ml-1" v-model="filtro.cpfCNPJ" @keyup.enter="fetchLista(filtro)" />
          </vs-col>                    
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="2">         
              <label class="vs-input--label ml-2">Fornecedor / Cliente</label>     
              <v-select                                               
                :options="CONSTANTE_COMBO_FORNECEDOR_CLIENTE" 
                v-model="filtro.comboFornecedorCliente"        
                :clearable="false"              
                class="v-select w-full ml-2">
              </v-select>                               
          </vs-col>  
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="2">         
              <label class="vs-input--label ml-2">Pessoa Física/Jurídica</label>     
              <v-select                                               
                :options="CONSTANTE_COMBO_TIPO_FAVORECIDO" 
                v-model="filtro.comboTipoFavorecido"        
                :clearable="false"              
                class="v-select w-full ml-2">
              </v-select>                               
          </vs-col>                   
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="3">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista(filtro)"></vs-button>
            <vs-button class="mr-2" color="dark" type="border" icon-pack="feather" icon="icon-file" @click="limparFiltros"></vs-button>  
            <vs-button class="mr-2" color="warning" type="filled" icon-pack="feather" icon="icon-plus" @click="routeNovoRegistro"></vs-button>          
            <vs-button color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-save" @click="exportarParaCSV" v-if="isGestor"></vs-button>          
          </vs-col>
      </vs-row>
    </vx-card>
     
    <h6 class="ml-2 mt-2 mb-2 text-danger"> {{dadosDaGrid.length }} registros </h6>
    <vx-card class="mb-1">
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :rowHeight="40"
        :headerHeight="20"        
        rowSelection="single"
        colResizeDefault="shift"
        @row-selected="onRowSelectedRegistro"    
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :paginationAutoPageSize="false"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>      
    </vx-card>
    
  </div>

</template>

<script>
import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

const URL_SERVLET = "/Favorecido/ListarFavorecido";
const NAME_ROUTE_EDIT = "cadastro-favorecidos-editar";

const CONSTANTE_COMBO_FORNECEDOR_CLIENTE = [
  {label:"Todos", data: "TODOS"},
	{label:"Só Cliente", data:"CLIENTE"},
	{label:"Só Fornecedor", data:"FORNECEDOR"}  
];

const CONSTANTE_COMBO_TIPO_FAVORECIDO = [
  {label:"Todos", data: "TODOS"},
	{label:"Pessoa Física", data:"PF"},
	{label:"Pessoa Jurídica", data:"PJ"}  
];

export default {
  components: {
    AgGridVue
  },
  data() {
    return {
      filtro : {nome: null, cpfCNPJ: null, comboFornecedorCliente: {label:"Todos", data: "TODOS"}, comboTipoFavorecido:  {label:"Todos", data: "TODOS"}},
      configuracaoGrid: { 
          gridApi: null, gridOptions: {}, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: 'C/F', field: 'ehCliente', width: 20,
              cellRenderer: function(params) {
                  return (params.data.ehCliente ? 'C' : '') + (params.data.ehFornecedor ? (params.data.ehCliente ? ' / ' : '') +  'F' : '')
              }
            },                                   
            { headerName: 'CPF/CNPJ', field: 'cpfCNPJ', width: 75 },                       
            { headerName: 'RAZÃO SOCIAL', field: 'razaoSocial', 
                cellRenderer: function(params) {
                  return '<strong>' + params.data.nome + '</strong><br/>' + params.data.razaoSocial;
                }
            },
            { headerName: 'COMERCIAL', field: 'telefoneComercial', width: 40},  
            { headerName: 'CELULAR', field: 'telefoneCelular', width: 40},                                                                                            
          ]
      },
      dadosDaGrid: [],
      totalRegistros: 0      
    }
  },  
  created() {
      this.CONSTANTE_COMBO_FORNECEDOR_CLIENTE = CONSTANTE_COMBO_FORNECEDOR_CLIENTE;
      this.CONSTANTE_COMBO_TIPO_FAVORECIDO = CONSTANTE_COMBO_TIPO_FAVORECIDO;
  },
  computed: {
    isGestor() {
      return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
    }
  },
  methods: {
    limparFiltros() {
      this.filtro = {nome:  null, cpfCNPJ: null, comboFornecedorCliente: "TODOS", comboTipoFavorecido: "TODOS" };      
    },
    fetchLista(pFiltro) {     
      this.$vs.loading() 
      const params = new URLSearchParams();
      params.append('pagina', -1);
      
      if (pFiltro.nome) {
        params.append('nome', pFiltro.nome);
      }

      if (pFiltro.cpfCNPJ) {
        params.append('cpfCNPJ', pFiltro.cpfCNPJ);
      }
      
      if (pFiltro.comboFornecedorCliente) {
        if (pFiltro.comboFornecedorCliente.data === 'CLIENTE') {
          params.append('ehCliente', true);
          params.append('ehFornecedor', false);
        } else if (pFiltro.comboFornecedorCliente.data === 'FORNECEDOR') {
          params.append('ehCliente', false);
          params.append('ehFornecedor', true);
        }
      }

      if (pFiltro.comboTipoFavorecido && pFiltro.comboTipoFavorecido.data) {
        if (pFiltro.comboTipoFavorecido.data !== 'TODOS') {          
            params.append('tipoPessoa', pFiltro.comboTipoFavorecido.data);
        }
      }

      axios.post(URL_SERVLET, params, {   
              headers: {'Accept': 'application/json' },           
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/' });
          } else {
            this.totalRegistros = response.data.Resultado.quantidade;              
            this.dadosDaGrid = response.data.Resultado.lista;
              
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
                        
    },
    routeNovoRegistro() {
      let self_ = this;

      self_.$router.push({
            name: NAME_ROUTE_EDIT                     
      })
    },
    onRowSelectedRegistro(evento) {
      let self_ = this;
      let registro = evento.node.data;
      
      self_.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: registro
            }
      })

    },
    exportarParaCSV() {
      var params = {columnSeparator: ';', fileName: 'Favorecidos.csv'};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    }
    
  },
  mounted() {
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api;
    this.configuracaoGrid.gridApi.sizeColumnsToFit();   
    if (this.$store.getters.filtroFavorecido) {
        this.filtro = JSON.parse(JSON.stringify(this.$store.getters.filtroFavorecido));
    }    
    this.fetchLista(this.filtro);
    
  },
  beforeDestroy() {    
    this.$store.dispatch('setarFiltro', {nomeTela: 'favorecido' , filtro: this.filtro});
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 310px);
  }
</style>
